// extracted by mini-css-extract-plugin
export var card = "_kk-5";
export var cardSelected = "_kk-4";
export var image = "_kk-3";
export var modal = "_kk-0";
export var modalContent = "_kk-1";
export var table = "_kk-2";